import React, { useState } from 'react'
import LineHeader from './LineHeader'
import ColumnContainer from './ColumnContainer'
import Tab from './Tab'
import '../../../assets/css/gamification2026/_tabbed_pages.scss'

const Tabs = (props) => {
  const { rows } = props
  const [activeTab, setActiveTab] = useState('')

  const onClickTabItem = (tab) => {
    setActiveTab(tab);
  }

  return (
    <div className="dashboard-layout">
      <nav className="dashboard-layout-navigation">
        {rows && rows.length > 0 && rows.map((row, idx) => {
          const { title } = row

          return (
              <Tab
                key={idx}
                activeTab={activeTab}
                label={title}
                onClick={onClickTabItem}
              />
          );
        })}
      </nav>
      <div className="tab-content">
        {rows && rows.length > 0 &&
          rows.map((row, key) => {
            const { rows: tabRows } = row
            if (row.title === activeTab) {
              return (
                <div key={key} className="w-full">
                  {
                    tabRows && tabRows.length > 0 &&
                    tabRows.map((rw, idx) => {
                      const { cols } = rw
                      return (
                        <div key={idx} className="dashboard-page-line">
                          <LineHeader {...rw} />
                          <div className="dashboard-columns-row">
                            {cols && cols.length > 0 &&
                              cols.map((col, key) => ( <ColumnContainer key={key} {...col} />))
                            }
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              )
            }
            return (
              <React.Fragment key={key}>
              </React.Fragment>
            )
          })
        }
      </div>
    </div>
  )
}

export default React.memo(Tabs);
